import { __assign } from "tslib";
import React from "react";
import { DropdownBox } from "../dropdown";
import { VirtualizedList as List, } from "../list/VirtualizedList";
import { useConfig } from "../util";
import { useIsomorphicLayoutEffect } from "../_util/use-isomorphic-layout-effect";
export function TagSelectBox(_a) {
    var listRef = _a.listRef, items = _a.items, onChange = _a.onChange, width = _a.width, scheduleUpdate = _a.scheduleUpdate, className = _a.className, _b = _a.style, style = _b === void 0 ? {} : _b, currentIndex = _a.currentIndex, onScrollBottom = _a.onScrollBottom, footer = _a.footer;
    useIsomorphicLayoutEffect(function () {
        scheduleUpdate();
    }, [scheduleUpdate, items]);
    var classPrefix = useConfig().classPrefix;
    var count = items.length;
    if (count === 0) {
        return null;
    }
    var hasGroup = !!items.find(function (item) { return item.type === "group"; });
    var boxStyle = __assign(__assign({}, style), { width: width });
    return (React.createElement(DropdownBox, { preventMouseDown: true, onClick: function (e) { return e.stopPropagation(); }, className: className, style: boxStyle, footer: footer },
        React.createElement(List, { containerStyle: boxStyle, containerClassName: className, virtualizedRef: listRef, type: hasGroup ? "option-group" : "option", items: items.map(function (item, index) {
                if (item.type === "option") {
                    var option_1 = item.option;
                    return __assign(__assign({}, item), { props: {
                            disabled: option_1.disabled,
                            current: currentIndex % count === index,
                            onClick: function (event) {
                                onChange(option_1.value, {
                                    event: event,
                                    option: option_1,
                                });
                            },
                            tooltip: option_1.tooltip,
                            className: hasGroup && !option_1.groupKey
                                ? classPrefix + "-list__item--single"
                                : "",
                        } });
                }
                return item;
            }), onScrollBottom: onScrollBottom })));
}
TagSelectBox.displayName = "TagSelectBox";
export function getListItems(_a) {
    var tips = _a.tips, options = _a.options, groups = _a.groups;
    var items = [];
    if (tips) {
        items.push({ type: "tips", key: "__tips", text: tips });
    }
    options.forEach(function (option, index) {
        if (option.groupKey &&
            (index === 0 || option.groupKey !== options[index - 1].groupKey)) {
            items.push({
                type: "group",
                key: option.groupKey + "-" + option.value,
                text: groups[option.groupKey],
            });
        }
        items.push({
            type: "option",
            key: option.value,
            text: typeof option.text === "undefined" ? option.value : option.text,
            option: option,
        });
    });
    return items;
}
//# sourceMappingURL=TagSelectBox.js.map